// src/screens/lazyNamed.js
import { lazy } from 'react';

export const lazyNamed = (factory, name) =>
    lazy(() =>
        factory().then((mod) => {
            const Comp = mod[name];
            if (!Comp) {
                throw new Error(
                    `Lazy import failed: "${name}" no existe en el módulo. Exports: ${Object.keys(mod).join(', ')}`
                );
            }
            return { default: Comp };
        })
    );
